export default function authHeaderImage() {
  const token = localStorage.getItem("access-token").replaceAll('"', "");

  if (token) {
    return {
      Authorization: "Bearer " + token,
    };
  } else {
    return {};
  }
}
